<template>
  <span class="PriceCell" :class="{ 'PriceCell--accent': accent }">
    <template v-if="price">
      <s v-if="price.original" class="PriceCell-original">{{ price.original }}</s>

      <span class="PriceCell-primary">{{ price.primary }}</span>
    </template>

    <template v-else>{{ EMPTY_CELL }}</template>
  </span>
</template>

<script setup lang="ts">
import { EMPTY_CELL } from './BasePlanComparisonTable.model';
import type { ComparisonPrice } from './BasePlanComparisonTable.model';

defineProps<{
  price?: ComparisonPrice;
  /** Promoted columns accent the price; the table owns which column that is. */
  accent?: boolean;
}>();
</script>

<style lang="scss">
@use '@cvo/ui/styles/design-system' as vars;
@use '@cvo/ui/styles/utils/text';

@layer cvo-ui {
  .PriceCell {
    display: flex;
    gap: vars.$dimensions-d-2;
    align-items: baseline;

    &-original {
      @include text.text('xs');
      color: vars.$organisms-table-comparison-table-content-strikethrough-text-color;
    }

    &-primary {
      @include text.text('sm', vars.$typography-weight-strong);
      color: inherit;
    }

    &--accent &-primary {
      color: vars.$organisms-table-comparison-table-content-accent-text-color;
    }
  }
}
</style>
